import ISO6391 from "iso-639-1";
import Cookie from "js-cookie";
import { use } from "react";

import { Select } from "~/components/Select";
import { useLocale } from "~/hooks/locale";
import { locales } from "~/i18n";
import { trackEvent } from "~/utils/analytics";

import { IPinfoContext } from "../IPinfoContext";

export const LanguageSelect: React.FC = () => {
  const { locale } = useLocale();
  const ipInfo = use(IPinfoContext);
  return (
    <Select
      className="lg:select-lg"
      value={locale}
      onChange={(event) => {
        trackEvent("game_language_changed");
        Cookie.set("locale", event.target.value);
        window.location.reload();
      }}
    >
      {locales.map((locale) => {
        const flag =
          locale === "en-US" && ipInfo
            ? ipInfo.countryCode === "US"
              ? "🇺🇸"
              : ipInfo.continent.code === "EU"
                ? "🇬🇧"
                : "🇨🇦"
            : locale
                .slice(-2) // get the country code
                .toUpperCase()
                .replace(/./g, (char) =>
                  // see: https://dev.to/jorik/country-code-to-flag-emoji-a21#comment-1d92e
                  String.fromCodePoint(127397 + char.charCodeAt(0)),
                );

        return (
          <option key={locale} value={locale}>
            {flag} {ISO6391.getNativeName(locale.slice(0, 2))}
          </option>
        );
      })}
    </Select>
  );
};
